import type { ReactNode } from 'react';

type View = 'capture' | 'report' | 'framework';
const NAV: { id: View; label: string }[] = [
  { id: 'capture', label: 'Capture' },
  { id: 'report', label: 'Report' },
  { id: 'framework', label: 'Framework' },
];

interface Props {
  view: View;
  onView: (v: View) => void;
  assigned: string;
  target: string;
  exportHref: string;
  children: ReactNode;
}

export function AppShell({ view, onView, assigned, target, exportHref, children }: Props) {
  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">Rung</div>
        <p className="tagline">
          Assigned {assigned} · arguing to {target}
        </p>
        <nav className="side-nav">
          {NAV.map((n) => (
            <button
              key={n.id}
              type="button"
              className={n.id === view ? 'side-link on' : 'side-link'}
              onClick={() => onView(n.id)}
            >
              {n.label}
            </button>
          ))}
        </nav>
        <a className="button-link ghost small export" href={exportHref} download="rung-export.json">
          Export JSON
        </a>
      </aside>
      <main className="work">{children}</main>
    </div>
  );
}
